import React from "react";

function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat(undefined, {
    year: "2-digit",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export default function CrmMergeHistory({ copy, mergeInfo }) {
  const rows = Array.isArray(mergeInfo?.history) ? mergeInfo.history : [];

  return (
    <section className="crm-mergeHistory">
      <h3>{copy.historyTitle}</h3>
      {rows.length ? (
        rows.map((row) => (
          <article key={row.id} className="crm-mergeHistoryRow">
            <span>
              {row.status === "merged" ? copy.merged : copy.unmerged} · {row.source_count || 0}
              {Array.isArray(row.source_entity_ids) && row.source_entity_ids.length
                ? ` (#${row.source_entity_ids.join(", #")})`
                : ""}
            </span>
            <span>{formatDateTime(row.created_at)}</span>
          </article>
        ))
      ) : (
        <div className="crm-tableEmpty">{copy.noHistory}</div>
      )}
    </section>
  );
}
